
import { mapGetters } from 'vuex'
import InnerLoading from '~/components/Shared/Loading/InnerLoading.vue'

const PAYMENT_INTERVALS = [
  { value: 0, key: 'daily' },
  { value: 1, key: 'weekly' },
  { value: 2, key: 'monthly' },
  { value: 3, key: 'yearly' },
]

const CURRENCY_MAP = {
  0: 'TRY',
  1: 'USD',
  2: 'EUR',
  3: 'GBP',
}

const PAYMENT_TYPE_KEYS = {
  RECURRING: 'pricing.paymentTypes.recurring',
  ONE_TIME: 'pricing.paymentTypes.oneTime',
  PREPAID: 'pricing.paymentTypes.prepaid',
}

export default {
  name: 'SubscriptionGetPackages',
  components: {
    InnerLoading,
  },
  data() {
    return {
      packages: [],
      isLoading: true,
      errorMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      getUserSubscriptions: 'user/getUserSubscriptions',
    }),
    hasPackages() {
      return this.packages.length > 0
    },
    userSubscriptionPackageIds() {
      const userSubs = Array.isArray(this.getUserSubscriptions)
        ? this.getUserSubscriptions
        : this.getUserSubscriptions?.subscriptions || []

      return userSubs
        .map((sub) => sub.subscriptionPackageId)
        .filter((id) => id != null && id !== undefined)
    },
  },
  mounted() {
    this.fetchPackages()
  },
  methods: {
    async fetchPackages() {
      this.isLoading = true
      this.errorMessage = ''

      try {
        const response = await this.$api.get('Subscription/GetPackages')
        const payload = response?.data ?? response
        const items =
          (Array.isArray(payload) && payload) ||
          (Array.isArray(payload?.data) && payload.data) ||
          (Array.isArray(payload?.items) && payload.items) ||
          (Array.isArray(payload?.data?.items) && payload.data.items) ||
          []

        this.packages = items
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          this.$custom$t('pricing.error')
      } finally {
        this.isLoading = false
      }
    },
    getIntervalMeta(value) {
      return PAYMENT_INTERVALS.find((interval) => interval.value === Number(value))
    },
    intervalLabel(value, variant = 'title') {
      console.log(value, "value", variant)
      const interval = this.getIntervalMeta(value)
      if (!interval) {
        return ''
      }

      if (variant === 'title') {
        return this.$custom$t(`pricing.intervalTabs.${interval.key}.title`)
      }

      return this.$custom$t(`pricing.intervalLabels.${interval.key}.${variant}`)
    },
    formatPrice(amount, currencyCode) {
      const currency =
        typeof currencyCode === 'string'
          ? currencyCode
          : CURRENCY_MAP[currencyCode] || 'TRY'

      try {
        return new Intl.NumberFormat(this.$i18n.locale || 'tr-TR', {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format(Number(amount) || 0)
      } catch (error) {
        return `${Number(amount) || 0} ${currency}`
      }
    },
    billingText(plan) {
      if (!plan.paymentInterval && !plan.paymentIntervalCount) {
        return ''
      }

      const interval = this.getIntervalMeta(plan.paymentInterval)
      if (!interval) {
        return ''
      }
      const intervalLabel = this.$custom$t(
        `pricing.intervalLabels.${interval.key}.single`
      ).toLowerCase()

      return this.$custom$t('pricing.card.billed', {
        count: plan.paymentIntervalCount || 1,
        interval: intervalLabel,
      })
    },
    paymentTypeLabel(type) {
      const key = PAYMENT_TYPE_KEYS[type] || PAYMENT_TYPE_KEYS.RECURRING
      return this.$custom$t(key)
    },
    trialLabel(plan) {
      if (!plan.trialPeriodDays) {
        return ''
      }
      return this.$custom$t('pricing.card.trial', {
        days: plan.trialPeriodDays,
      })
    },
    handlePlanSelect(plan) {
      this.$emit('plan-select', plan)
    },
    isPlanOwned(planId) {
      return this.userSubscriptionPackageIds.includes(Number(planId))
    },
  },
}
